<template>
  <div id="app" class="water-skin app-shell">
    <div class="mobile-viewport">
      <div class="app-main-wrap">
        <TopHeader v-show="showTopHeader" @wallet-authorized="handleWalletAuthorized" @user-connected="handleWalletAuthorized" />
        <main class="main-content" :class="{ 'full-screen': $route.meta.hideHeader }">
          <router-view v-slot="{ Component }">
            <keep-alive :include="tabKeepAliveNames">
              <component :is="Component" />
            </keep-alive>
          </router-view>
        </main>
      </div>
      <BottomNavigation v-if="!$route.meta.hideBottomNav" />
      <CustomerServiceButton v-if="showTopHeader" />
    </div>
  </div>
</template>

<script>
import TopHeader from './components/TopHeader.vue'
import BottomNavigation from './components/BottomNavigation.vue'
import CustomerServiceButton from './components/CustomerServiceButton.vue'
import domainService from './services/domainService.js'

export default {
  name: 'App',
  components: {
    TopHeader,
    BottomNavigation,
    CustomerServiceButton
  },
  computed: {
    showTopHeader() {
      return !this.$route.meta.hideHeader
    },
    tabKeepAliveNames() {
      return ['Home', 'WealthMarket', 'FarmPage', 'Assets']
    }
  },
  async mounted() {
    this.applySafeAreaBottom()
    window.addEventListener('resize', this.applySafeAreaBottom, { passive: true })
    window.visualViewport?.addEventListener('resize', this.applySafeAreaBottom, { passive: true })
    this.prefetchTabChunks()
    try {
      await domainService.init()
    } catch (error) {
      console.error('域名服务初始化失败:', error)
    }
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.applySafeAreaBottom)
    window.visualViewport?.removeEventListener('resize', this.applySafeAreaBottom)
  },
  methods: {
    applySafeAreaBottom() {
      try {
        const root = document.documentElement
        const probe = document.createElement('div')
        probe.style.cssText = 'position:fixed;left:0;bottom:0;width:0;height:env(safe-area-inset-bottom,0px);visibility:hidden;pointer-events:none;'
        document.body.appendChild(probe)
        const envInset = probe.getBoundingClientRect().height || 0
        probe.remove()

        const ua = navigator.userAgent || ''
        const isAndroid = /Android/i.test(ua)
        // 部分安卓三键导航下 env 为 0，但系统栏仍会叠在网页上
        const fallback = isAndroid && envInset < 1 ? 48 : 0
        const safeBottom = Math.max(envInset, fallback)
        root.style.setProperty('--app-safe-bottom', `${safeBottom}px`)
        root.classList.toggle('is-android', isAndroid)
      } catch (e) {
        /* ignore */
      }
    },
    prefetchTabChunks() {
      const run = () => {
        import('./views/WealthMarket.vue')
        import('./views/Farm.vue')
        import('./views/Assets.vue')
      }
      if (typeof window !== 'undefined' && 'requestIdleCallback' in window) {
        window.requestIdleCallback(run, { timeout: 1500 })
      } else {
        setTimeout(run, 600)
      }
    },
    handleWalletAuthorized() {
      this.refreshCustomerService()
    },
    async refreshCustomerService() {
      try {
        const userCustomerService = await domainService.getCurrentUserCustomerService()
        if (userCustomerService) {
          console.log('用户专属客服链接已更新:', userCustomerService)
        }
      } catch (error) {
        console.warn('刷新客服服务失败:', error)
      }
    }
  }
}
</script>

<style>
#app {
  min-height: 100vh;
  background: #e7f6f8;
  color: #16343d;
}

.app-main-wrap {
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;
}

.main-content {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
}

.main-content.full-screen { padding: 0; margin: 0; }

* { margin: 0; padding: 0; box-sizing: border-box; }

body {
  font-family: var(--font-ui);
  background: #cfe8ee;
  color: #16343d;
}

#app.water-skin,
#app.water-skin .app-main-wrap,
#app.water-skin .main-content {
  background: #e7f6f8;
  color: #16343d;
}

#app.water-skin .top-header {
  background: rgba(231, 246, 248, 0.94) !important;
  border-bottom: 0 !important;
}

#app.water-skin .bottom-navigation {
  background: rgba(255, 255, 255, 0.96) !important;
  border-top: 1px solid #d7eef3 !important;
}

#app.water-skin .nav-item {
  color: #111827 !important;
  font-weight: 700 !important;
}

#app.water-skin .nav-item.active {
  color: #111827 !important;
  background: #d7eef3 !important;
  box-shadow: inset 0 2px 0 #2eb4d4 !important;
}

      html, body {
        background: #cfe8ee;
        touch-action: manipulation;
      }
</style>
